module.exports = __webpack_public_path__ + "static/img/img3.cc7e39e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img3.png
// module id = m22b
// module chunks = 1